import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import Badge from "@material-ui/core/Badge";
import MailIcon from "@material-ui/icons/Mail";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import WarnIcon from "@material-ui/icons/ReportProblemOutlined";
import { FixedSizeList as List } from "react-window";
import { useFeedback } from "../../feedback/Feedback";
import Moment from "moment";
var styles = function styles(theme) {
  return {
    card: {
      minWidth: 600,
      maxWidth: 600
    },
    iconButtonAvatar: {
      padding: 2
    },
    caption: {
      textAlign: "center"
    },
    infoIcon: {
      color: "#D6D6D6",
      marginRight: 20,
      marginLeft: 5
    },
    errorIcon: {
      color: "#FF5A5A",
      marginRight: 20,
      marginLeft: 5
    },
    warnIcon: {
      color: "#ffa059",
      marginRight: 20,
      marginLeft: 5
    },
    listItem: {
      whiteSpace: "nowrap",
      overflowX: "hidden"
    }
  };
};
var createTimestampMessage = function createTimestampMessage(timestampMillis) {
  return Moment(new Date(timestampMillis)).fromNow();
};
var createListItems = function createListItems(feedback) {
  var lastTimestampMessage;
  var items = [];
  feedback.forEach(function (message) {
    var timestampMessage = createTimestampMessage(message.timestamp);
    if (lastTimestampMessage !== timestampMessage) {
      lastTimestampMessage = timestampMessage;
      items.push({
        message: timestampMessage
      });
    }
    items.push(message);
  });
  return items;
};
var MessagesButton = function MessagesButton(_ref) {
  var classes = _ref.classes;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    accountDetailsAnchor = _React$useState2[0],
    setAccountDetailsAnchor = _React$useState2[1];
  var _useFeedback = useFeedback(),
    _useFeedback2 = _slicedToArray(_useFeedback, 2),
    feedback = _useFeedback2[0],
    setFeedback = _useFeedback2[1];
  var _React$useState3 = React.useState(feedback.length),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    acknowledgedMessageCount = _React$useState4[0],
    setAcknowledgedMessageCount = _React$useState4[1];
  var handleHide = function handleHide() {
    setAccountDetailsAnchor(null);
    setAcknowledgedMessageCount(feedback.length);
  };
  var handleClear = function handleClear() {
    setFeedback([]);
    setAcknowledgedMessageCount(0);
  };
  var items = createListItems(feedback);
  var itemCount = items.length;
  var itemSize = 50;
  var listHeight = itemCount * itemSize;
  if (listHeight > 400) {
    listHeight = 400;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Feedback Messages"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    onClick: function onClick(event) {
      return setAccountDetailsAnchor(event.currentTarget);
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    color: "secondary",
    badgeContent: feedback.length - acknowledgedMessageCount
  }, /*#__PURE__*/React.createElement(MailIcon, null)))), /*#__PURE__*/React.createElement(Popover, {
    disableScrollLock: true,
    open: accountDetailsAnchor !== null,
    anchorEl: accountDetailsAnchor,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleHide
  }, /*#__PURE__*/React.createElement(Card, {
    elevation: 2,
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.title
    }, "Messages")
  }), /*#__PURE__*/React.createElement(CardContent, null, itemCount === 0 ? /*#__PURE__*/React.createElement(Typography, {
    className: classes.caption,
    color: "textSecondary"
  }, "No messages") : /*#__PURE__*/React.createElement(List, {
    height: listHeight,
    width: "100%",
    itemSize: itemSize,
    itemCount: itemCount,
    initialScrollOffset: Math.max(0, itemCount * itemSize - listHeight)
  }, function (_ref2) {
    var index = _ref2.index,
      style = _ref2.style;
    var feedbackMessage = items[index];
    var icon;
    if (feedbackMessage.severity) {
      icon = feedbackMessage.severity == "ERROR" ? /*#__PURE__*/React.createElement(ErrorIcon, {
        className: classes.errorIcon
      }) : feedbackMessage.severity == "WARNING" ? /*#__PURE__*/React.createElement(WarnIcon, {
        className: classes.warnIcon
      }) : /*#__PURE__*/React.createElement(InfoIcon, {
        className: classes.infoIcon
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      key: index
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: feedbackMessage.message
    }, /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      disableGutters: true
    }, icon, /*#__PURE__*/React.createElement(ListItemText, {
      secondary: feedbackMessage.message,
      className: classes.listItem
    }))));
  })), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    onClick: handleClear
  }, "Clear"))))));
};
export default withStyles(styles)(MessagesButton);